<template>
  <lazy-div :load="doInit">
    <v-card>
      <v-card-title>
        <div>
          <div class="headline">Summary</div>
        </div>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-title>
        <div class="body-2">{{labels.general}}</div>
      </v-card-title>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex xs4>
              <v-subheader class="queryLabel">{{labels.statsType}}</v-subheader>
            </v-flex>
            <v-flex xs8>
              <div class="subheading">{{statsTypeForm.statsType}}</div>
            </v-flex>
            <v-flex xs4>
              <v-subheader class="queryLabel">{{labels.statsTypeDesc}}</v-subheader>
            </v-flex>
            <v-flex xs8>
              <div class="subheading">{{statsTypeForm.statsTypeDesc}}</div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-title>
        <div class="body-2">{{labels.riskFactor}}</div>
      </v-card-title>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex xs4>
              <v-subheader class="queryLabel">{{labels.mtrRiskFact}}</v-subheader>
            </v-flex>
            <v-flex xs8>
              <div class="subheading">{{formatBoolean(statsTypeForm.mtrRiskFact)}}</div>
            </v-flex>
            <v-flex xs4>
              <v-subheader class="queryLabel">{{labels.pkgRiskFact}}</v-subheader>
            </v-flex>
            <v-flex xs8>
              <div class="subheading">{{formatBoolean(statsTypeForm.pkgRiskFact)}}</div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-title>
        <div>
          <div class="headline">{{labels.valueList}}</div>
        </div>
        <v-spacer></v-spacer>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-card-title>
      <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="name" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <span slot="activator">
              {{ props.header.text }}
            </span>
            <span>
              {{ props.header.text }}
            </span>
          </v-tooltip>
        </template>
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.statsVal }}</td>
          <td class="text-xs-left">{{ props.item.statsValDesc }}</td>
          <td class="text-xs-left">{{ formatBoolean(props.item.defAsBen) }}</td>
        </template>
      </v-data-table>
    </v-card>
  </lazy-div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { expandURI } from '@/utils/ajax'
import FieldMixin from '@/mixins/field'
export default {
  props: ['id'],
  data() {
    return {
      headers: [
        { text: 'Statistics Value Code', value: 'statsVal' },
        { text: 'Statistics Value Description', value: 'statsValDesc' },
        { text: 'Default Value', value: 'defAsBen' }
      ],
      labels: {
        general: 'Statistics Details',
        riskFactor: 'Risk Factor',
        valueList: 'Value Listing',
        statsType: 'Statistics Type Code',
        statsTypeDesc: 'Statistics Type Description',
        mtrRiskFact: 'Motor',
        pkgRiskFact: 'Package'
      },
      statsTypeForm: {
        statsType: null,
        statsTypeDesc: null,
        mtrRiskFact: null,
        pkgRiskFact: null
      }
    }
  },
  computed: {
    statistics() {
      return this.$store.state.parameters.statistics
    }
  },
  methods: {
    async statsTypeFormInit() {
      const apiURI = this.statistics.menu.StatsType
      if (apiURI) {
        try {
          const expand = {
            statsType: this.id
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.statsTypeForm.statsType = data.statsType.statsType
            this.statsTypeForm.statsTypeDesc = data.statsType.statsTypeDesc
            this.statsTypeForm.mtrRiskFact = data.statsType.mtrRiskFact
            this.statsTypeForm.pkgRiskFact = data.statsType.pkgRiskFact
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doInit() {
      this.loading = true
      const apiURI = this.statistics.menu.StatsValues
      if (apiURI) {
        try {
          const expand = {
            statsType: this.id
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((statsVal) => {
              const convertStatsVal = {
                statsType: statsVal.statsType,
                statsTypeDesc: statsVal.statsTypeDesc,
                statsVal: statsVal.statsVal,
                statsValDesc: statsVal.statsValDesc,
                defAsBen: statsVal.defAsBen
              }
              this.items.push(convertStatsVal)
            })
            this.loading = false
          }
        } catch (error) {
          this.loading = false
        }
      } else {
        this.loading = false
      }
    }
  },
  created() {
    Promise.all([this.statsTypeFormInit(), this.doInit()])
  },
  mixins: [
    TableConst.default,
    FieldMixin
  ]
}
</script>

<style>

</style>
